"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("avo/index");
var _view = _interopRequireDefault(require("./view"));
var _state = _interopRequireDefault(require("./state"));
var _ErrorBoundary = require("ErrorBoundary");
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); } // @ts-nocheck
(0, _index.subscribeToAvo)();
try {
  var _APP_CONFIG, _APP_CONFIG2, _APP_CONFIG3, _APP_CONFIG4, _APP_CONFIG5;
  Sentry.init({
    enabled: (_APP_CONFIG = APP_CONFIG) === null || _APP_CONFIG === void 0 || (_APP_CONFIG = _APP_CONFIG.sentry) === null || _APP_CONFIG === void 0 ? void 0 : _APP_CONFIG.enabled,
    dsn: (_APP_CONFIG2 = APP_CONFIG) === null || _APP_CONFIG2 === void 0 ? void 0 : _APP_CONFIG2.sentry.dsn,
    environment: (_APP_CONFIG3 = APP_CONFIG) === null || _APP_CONFIG3 === void 0 || (_APP_CONFIG3 = _APP_CONFIG3.sentry) === null || _APP_CONFIG3 === void 0 ? void 0 : _APP_CONFIG3.env,
    debug: !IS_PROD,
    release: APP_VERSION,
    sampleRate: (_APP_CONFIG4 = APP_CONFIG) === null || _APP_CONFIG4 === void 0 || (_APP_CONFIG4 = _APP_CONFIG4.sentry) === null || _APP_CONFIG4 === void 0 ? void 0 : _APP_CONFIG4.sampleRate,
    tracesSampleRate: (_APP_CONFIG5 = APP_CONFIG) === null || _APP_CONFIG5 === void 0 || (_APP_CONFIG5 = _APP_CONFIG5.sentry) === null || _APP_CONFIG5 === void 0 ? void 0 : _APP_CONFIG5.tracesSampleRate,
    maxBreadcrumbs: 10
  });
  var trackerProperties = window.trackerProperties;
  if (trackerProperties && trackerProperties.analyticsId) {
    Sentry.setUser({
      id: trackerProperties.analyticsId
    }); // this is being set by web repo code

    Sentry.setExtras({
      userId: trackerProperties === null || trackerProperties === void 0 ? void 0 : trackerProperties.guestId,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      created_at: trackerProperties === null || trackerProperties === void 0 ? void 0 : trackerProperties.createdAt,
      path: window.location.href
    });
  }
} catch (e) {
  console.error(e);
}
var AuthSignin = function AuthSignin(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary.ErrorBoundary, {
    "data-sentry-element": "ErrorBoundary",
    "data-sentry-component": "AuthSignin",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_state["default"], {
    "data-sentry-element": "AuthSigninProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_view["default"], {
    "data-sentry-element": "AuthSigninView",
    "data-sentry-source-file": "index.tsx"
  })));
};
var container = document.getElementById('auth-signin-container-wrap');
if (container) {
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require('react-dom/client'));
  }).then(function (_ref2) {
    var createRoot = _ref2.createRoot;
    var root = createRoot(container);
    root.render(/*#__PURE__*/_react["default"].createElement(AuthSignin, null));
  });
}
var _default = exports["default"] = AuthSignin;